import { pop as popLinkData } from "./link-data";
import * as accessPath from "./accesspath";
import { getDeviceLabels } from "./browser-basics";
import { provideContext } from "./context-provider";
import { createRandomId } from "./compute-ids";
import { sendEventToGate, sendMergeToGate, sendMergeToGateViaFetch } from "./request";
import { submitStoredMove } from "./move";
import { DataContainer, parseDataContainer } from "./datacontainer";
import { TSID } from "./context";
import { EventMergeContext } from "./eventMergeContext";
import { internals } from "./util";
import { isUrlBlocked } from "./ad-block";
import { isBeaconApiSupported } from "./util";
import { getPagecluster } from "@otto-ec/global-resources/misc"

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function createEventMergeContext(): EventMergeContext {
  const id = createRandomId(10);
  return {
    sendEventToTrackingServer: (dataContainer: DataContainer) => sendEventToGate(dataContainer, id),
    submitEventMerge: async (dataContainer) => {
      await sendEventToGate(dataContainer, id);
    },
    eventMergeId: id,
  } as EventMergeContext;
}

export function forceInitialPageImpression(dataContainer: DataContainer) {
  const linkData = popLinkData();
  sendMergeToGate(Object.assign(linkData, dataContainer), "default");
  submitStoredMove();
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function createContext(id: string, url: string, dataContainer?: DataContainer): Array<TSID> {
  const context = provideContext();
  const currentContextStack = context.create(id, url);

  forceInitialPageImpression(parseDataContainer(dataContainer || {}));

  return currentContextStack;
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export function replaceContext(id: string, url: string, dataContainer: DataContainer): Array<TSID> {
  const context = provideContext();
  const currentContextStack = context.replace(id, url);

  forceInitialPageImpression(parseDataContainer(dataContainer));

  return currentContextStack;
}

/**
 *
 *
 */
export function closeContext(): void {
  const context = provideContext();

  if (context.stack.length > 1) {
    sendEventToGate({
      ts_LayerEvent: ["close"],
    });
  }

  context.close();
}

export async function init() {
  if (internals.TRACKING_bctdatainitialized) {
    return;
  }
  internals.TRACKING_bctdatainitialized = true;

  accessPath.update(document.referrer);

  const pageCluster = getPagecluster();
  const pageClusterLabels = pageCluster ? { ts_DataPageCluster: [pageCluster] } : {};

  const params = {
    ...accessPath.getMergeParameters(),
    ...getDeviceLabels(),
    ...pageClusterLabels,
    ts_Js: ["true"]
  } as DataContainer;

  if (isBeaconApiSupported()) {
    params["ts_ClientRequestType"] = ["beacon"];
    void sendMergeToGateViaFetch({"ts_ClientRequestType": ["fetch"] });
  } else {
    params["ts_ClientRequestType"] = ["beaconFallback"];
  }

  const urlBlocked = await isUrlBlocked(fetch);
  if (!urlBlocked) {
    params["ot_UrlBlocked"] = ["false"];
  }

  /*                                                     */
  void sendMergeToGate(params);

  window.addEventListener("beforeunload", () => {
    accessPath.storeUnloadedLocationHref();
  });

  window.addEventListener("pagehide", () => {
    accessPath.storeUnloadedLocationHref();
  });
}
